import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {
    useTable,
    useGlobalFilter,
    useSortBy,
    useFilters,
    useExpanded,
    usePagination,
} from "react-table";
import {Table, Row, Col, Form, Dropdown} from "react-bootstrap";
import {Filter, DefaultColumnFilter} from "./Filter";
import {Link} from "react-router-dom";
import {useTranslation} from "react-i18next";
import {exportAlertsToExcel, printAlerts} from "../../utils/exportUtils";


interface GlobalFilterProps {
    preGlobalFilteredRows?: any;
    globalFilter?: any;
    setGlobalFilter?: any;
    SearchPlaceholder?: string;
    isProductsFilter?: boolean;
}

function GlobalFilter({
                          globalFilter,
                          setGlobalFilter,
                      }: GlobalFilterProps) {
    const {t} = useTranslation();
    const [value, setValue] = React.useState(globalFilter);
    const onChange = (value: any) => {
        setGlobalFilter(value || undefined);
    };

    return (
        <React.Fragment>

            <div className="search-box">
                <Form.Control
                    type="text"
                    placeholder={t('Alerts.search_alert')}

                    value={value || ""}
                    onChange={(e: any) => {
                        setValue(e.target.value);
                        onChange(e.target.value);
                    }}/>
                <i className="las la-search search-icon"></i>
            </div>


        </React.Fragment>
    );
}

interface TableContainerProps {
    columns?: any;
    data?: any;
    isGlobalFilter?: any;
    isAddOptions?: any;
    divClassName?: any;
    tableClassName?: any;
    theadClassName?: any;
    tableClass?: any;
    theadClass?: any;
    isBordered?: boolean;
    isAddUserList?: any;
    handleOrderClicks?: any;
    handleUserClick?: any;
    handleCustomerClick?: any;
    isAddCustList?: any;
    customPageSize?: any;
    className?: any;
    customPageSizeOptions?: any;
    iscustomPageSize?: boolean;
    SearchPlaceholder?: string;
    isProductsFilter?: boolean;
    isPagination?: boolean;
    PaginationClass?: any;
}

const TableContainer = ({
                            columns,
                            data,
                            tableClass,
                            theadClass,
                            divClassName,
                            isBordered,
                            isGlobalFilter,
                            isProductsFilter,
                            isPagination,
                            customPageSize,
                            iscustomPageSize,
                            SearchPlaceholder,
                            PaginationClass,
                        }: TableContainerProps) => {
    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        page,
        prepareRow,
        canPreviousPage,
        canNextPage,
        pageOptions,
        gotoPage,
        nextPage,
        previousPage,
        state,
        preGlobalFilteredRows,
        setGlobalFilter,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            defaultColumn: {Filter: DefaultColumnFilter},
            initialState: {
                pageIndex: 0,
                pageSize: customPageSize,
                sortBy: [
                    {
                        desc: true,
                        // asce: true,
                    },
                ],
            },
        },
        useGlobalFilter,
        useFilters,
        useSortBy,
        useExpanded,
        usePagination
    );


    const {t} = useTranslation();


    return (
        <Fragment>
            {(iscustomPageSize || isGlobalFilter) && (
                <Row className="mb-2">
                    {isGlobalFilter && (
                        <div>
                            <Row>
                                <Col xl={11}>
                                    <GlobalFilter
                                        preGlobalFilteredRows={preGlobalFilteredRows}
                                        globalFilter={state.globalFilter}
                                        setGlobalFilter={setGlobalFilter}
                                        SearchPlaceholder={SearchPlaceholder}
                                        isProductsFilter={isProductsFilter}
                                    />
                                </Col>
                                <Col xl={1}>
                                    <Dropdown>
                                        <Dropdown.Toggle as="button"
                                                         className="btn btn-primary btn-icon fs-14 arrow-none"><i
                                            className="las la-ellipsis-v fs-18"></i>
                                        </Dropdown.Toggle>
                                        <Dropdown.Menu>
                                            <Dropdown.Item onClick={()=> printAlerts(data)}>
                                                <i className="las la-print fs-18 align-middle me-2 text-muted"></i>
                                                {t('Alerts.print')}
                                            </Dropdown.Item>
                                            <Dropdown.Item onClick={()=> exportAlertsToExcel(data)}>
                                                <i className="las la-file-csv fs-18 align-middle me-2 text-muted"></i>
                                                {t('Alerts.excel')}
                                            </Dropdown.Item>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </Col>
                            </Row>
                        </div>
                    )}
                </Row>
            )}

            <div className={divClassName ? divClassName : "table-responsive"}>
                <Table
                    {...getTableProps()}
                    className={tableClass}
                    bordered={isBordered}
                >
                    <thead className={theadClass}>
                    {headerGroups.map((headerGroup: any, headerGroupIndex: number) => {
                        const {key, ...restHeaderGroupProps} =
                            headerGroup.getHeaderGroupProps();
                        return (
                            <tr
                                key={headerGroup.id || `headerGroup-${headerGroupIndex}`}
                                {...restHeaderGroupProps}
                            >
                                {headerGroup.headers.map(
                                    (column: any, columnIndex: number) => {
                                        const {key, ...restColumnProps} =
                                            column.getSortByToggleProps();
                                        return (
                                            <th
                                                key={column.id || `column-${columnIndex}`}
                                                className={`${column.isSortable ? "sort" : ""} ${
                                                    column.istext ? "text-start" : ""
                                                }`}
                                                {...restColumnProps}
                                            >
                                                {column.render("Header")}
                                                <Filter column={column}/>
                                            </th>
                                        );
                                    }
                                )}
                            </tr>
                        );
                    })}
                    </thead>

                    <tbody {...getTableBodyProps()}>
                    {page.map((row: any) => {
                        prepareRow(row);
                        const {key: rowKey, ...restRowProps} = row.getRowProps(); // Extract the key from row props
                        return (
                            <Fragment key={rowKey}>
                                <tr {...restRowProps}>
                                    {row.cells.map((cell: any) => {
                                        const {key: cellKey, ...restCellProps} =
                                            cell.getCellProps(); // Extract the key from cell props
                                        return (
                                            <td key={cellKey} {...restCellProps}>
                                                {cell.render("Cell")}
                                            </td>
                                        );
                                    })}
                                </tr>
                            </Fragment>
                        );
                    })}
                    </tbody>
                </Table>
            </div>

            {isPagination && (
                <Row className={PaginationClass} id="pagination-element">
                    <div className="col-sm">
                        <div className="text-muted">
                            <span className="fw-semibold ms-1">
                              {pageIndex * pageSize + 1} – {Math.min((pageIndex + 1) * pageSize, data.length)}
                            </span>/
                            <span className="fw-semibold">{data.length}</span>
                        </div>
                    </div>
                    <div className="col-sm-auto ms-auto">
                        <ul className="pagination mb-0">
                            <li
                                className={
                                    !canPreviousPage ? "page-item disabled" : "page-item"
                                }
                            >
                                <Link
                                    to="#"
                                    className="page-link pagination-prev"
                                    onClick={previousPage}
                                >
                                    {t('Alerts.previous')}
                                </Link>
                            </li>
                            {pageOptions.map((item: any, key: number) => (
                                <React.Fragment key={key}>
                                    <li className="page-item">
                                        <Link
                                            to="#"
                                            className={
                                                pageIndex === item ? "page-link active" : "page-link"
                                            }
                                            onClick={() => gotoPage(item)}
                                        >
                                            {item + 1}
                                        </Link>
                                    </li>
                                </React.Fragment>
                            ))}
                            <li className={!canNextPage ? "page-item disabled" : "page-item"}>
                                <Link
                                    to="#"
                                    className="page-link pagination-next"
                                    onClick={nextPage}
                                >
                                    {t('Alerts.next')}
                                </Link>
                            </li>
                        </ul>
                    </div>
                </Row>
            )}
        </Fragment>
    );
};

TableContainer.propTypes = {
    preGlobalFilteredRows: PropTypes.any,
};

export default TableContainer;
